import { Controller } from "@hotwired/stimulus";

/**
 * Plays a thumbnail-sized video on hover and rewinds to the poster frame on
 * leave. Attach to the <video> element itself (or a wrapper with a video
 * target). No-op on touch devices, where the native controls (if any) apply.
 *
 * Usage:
 *   <video data-controller="hover-video"
 *          data-action="mouseenter->hover-video#play mouseleave->hover-video#stop"
 *          src="...#t=0.1" preload="metadata" muted loop></video>
 */
export default class HoverVideoController extends Controller {
  static targets = ["video"];

  declare readonly videoTargets: HTMLVideoElement[];

  private get video(): HTMLVideoElement | null {
    if (this.element instanceof HTMLVideoElement) return this.element;
    return this.videoTargets[0] ?? null;
  }

  play(): void {
    if (window.matchMedia("(hover: none)").matches) return;
    this.video?.play().catch(() => {});
  }

  stop(): void {
    const video = this.video;
    if (!video) return;
    video.pause();
    video.currentTime = 0.1;
  }
}
